import React, { FC, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

import { FilterSelect } from '../../../components/FilterSelect'
import { TableSmall } from '../../../components/TableSmall'
import { useRest } from '../../../components/Context'
import { IData } from '../HomeTableLists'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    paddingTop: theme.spacing(4),
    maxWidth: 552,
  },
  container: {
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  table: {
    width: '100%',
    padding: '0 32px',
    background: 'rgba(216, 216, 216, 0.05)',
  },
}))
interface HomeSectionProps {
  title: string
  data: IData
}

export const HomeSection: FC<HomeSectionProps> = ({ title, data }) => {
  const classes = useStyles()

  const formMethods = useForm({
    mode: 'onBlur',
  })

  const { rxios } = useRest()

  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})

  const loadData = useCallback(async () => {
    let cleanupFunction = false
    setLoading(true)
    rxios.get(data.request).subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setValues(next)
        if (!cleanupFunction) setLoading(false)
      },
      (error) => {
        toast.error(error)
        setLoading(false)
      },
      () => {
        setLoading(false)
      },
    )
    cleanupFunction = true
    // eslint-disable-next-line
  }, [rxios])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [])

  return (
    <Grid item xs={12} className={classes.formWrap}>
      <FormProvider {...formMethods}>
        <Grid item xs={12} md={6} className={classes.container}>
          <Typography variant={'h6'}>{title}</Typography>
          <FilterSelect inputName={'timeInterval'} placeholder={'last 24 hours'} width={137} padding={'3px 15px'} />
        </Grid>

        <Grid container className={classes.table}>
          <TableSmall
            columns={data.columns}
            data={values.pairs}
            firstSum={values.total}
            secondSum={values.revenue}
            loading={loading}
          />
        </Grid>
      </FormProvider>
    </Grid>
  )
}
